import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Users, Store, Package, Receipt, DollarSign, ShieldCheck, Bike, Rocket,
  Megaphone, List, CreditCard, Eye, Layers, Share2, Tag,
} from "lucide-react";
import { api } from "../../lib/api";
import { Loader } from "../../components/Loader";
import { PageHeader } from "../../components/PageHeader";

const LINKS = [
  ["broadcast", "إرسال إشعار", Megaphone], ["users", "إدارة المستخدمين", Users],
  ["categories", "القوائم", List], ["specializations", "تخصصات المتاجر", Store],
  ["disputes", "فض النزاعات", ShieldCheck], ["withdrawals", "السحوبات", CreditCard],
  ["interests", "الاهتمامات", Layers], ["payment-methods", "طرق الدفع", CreditCard],
  ["subscription", "اشتراك البائعين", Rocket], ["driver-subscription", "اشتراك السائقين", Bike],
  ["promo-packages", "باقات التمويل", Rocket], ["driver-applications", "طلبات السائقين", Bike],
  ["cities", "المدن", List], ["delivery-settings", "إعدادات التوصيل", Bike],
  ["chats", "مراقبة المحادثات", Eye], ["followers", "المتابعين", Users],
  ["platform-social", "روابط التواصل", Share2], ["app-version", "اسم الإصدار", Tag],
];

export default function AdminDashboard() {
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);
  useEffect(() => { api("/admin/stats").then(setStats).catch(() => setStats({})); }, []);
  if (!stats) return <Loader />;
  const cards = [
    ["المستخدمون", stats.total_users, Users, "#7C5CFF"],
    ["المتاجر", stats.total_sellers, Store, "#FF8A3C"],
    ["السائقون", stats.total_drivers, Bike, "#3F8CFF"],
    ["المنتجات", stats.total_products, Package, "#00C2C7"],
    ["الطلبات", stats.total_orders, Receipt, "#FF3D5A"],
    ["الإيرادات (GMV)", `${Number(stats.gmv || 0).toFixed(0)} د.ل`, DollarSign, "#00D26A"],
    ["أرباح المنصة", `${Number(stats.platform_revenue || 0).toFixed(0)} د.ل`, DollarSign, "#7C5CFF"],
    ["محافظ المستخدمين", `${Number(stats.total_wallets || 0).toFixed(0)} د.ل`, DollarSign, "#FFB627"],
  ];
  return (
    <div className="animate-fade-in-up max-w-5xl mx-auto">
      <PageHeader title="لوحة الإحصائيات" backTo="/profile" />
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {cards.map(([label, val, Icon, color]) => (
          <div key={label} className="bg-white rounded-2xl border border-[#E8EAF2] p-4">
            <div className="w-10 h-10 rounded-xl flex items-center justify-center text-white" style={{ backgroundColor: color }}><Icon size={20} /></div>
            <p className="text-2xl font-black text-[#161629] mt-3">{val ?? 0}</p>
            <p className="text-xs text-[#6B7280]">{label}</p>
          </div>
        ))}
      </div>
      <h2 className="font-black text-[#161629] mt-6 mb-3">إدارة المنصة</h2>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
        <button data-testid="admin-link-live-orders" onClick={() => navigate("/admin-live-orders")} className="flex items-center gap-3 p-4 bg-white rounded-2xl border border-[#E8EAF2] hover:brand-shadow-sm text-start">
          <Receipt size={20} className="text-[#FF3D5A]" /><span className="font-bold text-sm text-[#161629]">الطلبات الحالية</span>
        </button>
        <button data-testid="admin-link-help" onClick={() => navigate("/admin-help")} className="flex items-center gap-3 p-4 bg-white rounded-2xl border border-[#E8EAF2] hover:brand-shadow-sm text-start">
          <List size={20} className="text-[#FF3D5A]" /><span className="font-bold text-sm text-[#161629]">تعديل المساعدة</span>
        </button>
        {LINKS.map(([slug, label, Icon]) => (
          <button key={slug} data-testid={`admin-link-${slug}`} onClick={() => navigate(`/admin/${slug}`)} className="flex items-center gap-3 p-4 bg-white rounded-2xl border border-[#E8EAF2] hover:brand-shadow-sm text-start">
            <Icon size={20} className="text-[#FF3D5A]" /><span className="font-bold text-sm text-[#161629]">{label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
